// extracted by mini-css-extract-plugin
export default {"statusMessage":"SubTableInfo_statusMessage__wdJOR","placeHolderShimmer":"SubTableInfo_placeHolderShimmer__tci7h"};